import { useQuery } from 'react-query'
import { notification } from 'antd'

import { QUERY_KEYS } from '@api'

import { BlockTrainFileTypeApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error',
  })
}

const useBlockTrainFileTypes = () => {
  const { data, isLoading } = useQuery(
    QUERY_KEYS.BLOCKTRAIN_FILE_TYPE,
    BlockTrainFileTypeApi.getBlockTrainFileTypes,
    {
      staleTime: Infinity,
      onError,
    },
  )

  return {
    fileTypes: data,
    isLoading,
  }
}

export { useBlockTrainFileTypes }
